










































































import { ElSortParams } from "@/core/models";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class GridTableCpt extends Vue {
  @Prop({ type: Array, required: false, default: () => [] }) data: any[]; // Table data
  @Prop({ type: Array, required: true }) columns: any[]; // Column definitions
  @Prop({ type: Boolean, default: false }) stripe: boolean; // Striped rows
  @Prop({ type: Boolean, default: false }) border: boolean;
  @Prop({ type: String, required: false, default: "100%" }) maxHeight: string; // Table border
  @Prop({ type: String, required: false, default: "" }) sortBy: string;
  @Prop({ type: String, required: false, default: "" }) sortOrder: string;
  @Prop({ type: String, required: false, default: "" }) search: string;
  @Prop({ type: String, required: false, default: "" }) searchProp: string;
  @Prop({ type: Boolean, required: false, default: false }) isInternalSorter: boolean;

  internalSortBy = "";
  internalSortOrder = "";

  @Watch("sortBy")
  onSortByChanged(val: string, oldVal: any) {
    this.internalSortBy = val;
  }

  @Watch("sortOrder")
  onSortOrderChanged(val: string, oldVal: any) {
    this.internalSortOrder = val;
  }

  get sortedData() {
    if (!this.data) {
      return [];
    }

    if (!this.isInternalSorter) {
      return this.data;
    }

    const sortProp = !this.internalSortBy ? this.sortBy : this.internalSortBy;

    const filtered = this.data.filter(
      (data: any) =>
        !this.searchProp || !this.search || data[this.searchProp].toLowerCase().includes(this.search.toLowerCase()),
    );

    if (!filtered.length || !this.internalSortOrder || !sortProp || !filtered[0].hasOwnProperty(sortProp)) {
      return filtered; // Return unsorted if the property doesn't exist
    }

    const firstValue = filtered[0][sortProp];
    const valueType = typeof firstValue;

    return filtered.sort((a: any, b: any) => {
      let aValue = a[sortProp];
      let bValue = b[sortProp];

      if (valueType === "boolean") {
        aValue = aValue ? 1 : 0;
        bValue = bValue ? 1 : 0;
      }

      if (this.internalSortOrder.startsWith("desc")) {
        return valueType === "string" ? bValue.localeCompare(aValue) : bValue - aValue;
      } else {
        return valueType === "string" ? aValue.localeCompare(bValue) : aValue - bValue;
      }
    });
  }

  // Handle sorting
  handleSort(column: any) {
    if (column.sortable) {
      this.internalSortBy = column.prop;
      this.internalSortOrder = !this.internalSortOrder
        ? "ascending"
        : this.internalSortOrder === "asc" || this.internalSortOrder === "ascending"
        ? "descending"
        : "";
      const sortParam = new ElSortParams();
      sortParam.column = column;
      sortParam.prop = this.internalSortBy;
      sortParam.order = this.internalSortOrder;
      this.$emit("sort-change", sortParam);
    }
  }
}
